import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { codes: Array };

  copyRecoveryCodes(event) {
    event.preventDefault();

    const codesText = this.codesValue.join("\n");

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(codesText)
        .then(() => {
          this.showNotification("Codes copied to clipboard");
        })
        .catch(() => {
          this.fallbackCopy(codesText);
        });
    } else {
      this.fallbackCopy(codesText);
    }
  }

  downloadRecoveryCodes(event) {
    event.preventDefault();

    const codesText = this.codesValue.join("\n");
    const blob = new Blob([codesText], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "healpay-hub-recovery-codes.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.showNotification("Codes downloaded successfully");
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    this.showNotification("Codes copied to clipboard");
  }

  showNotification(message) {
    const notification = document.createElement("div");
    notification.className = "toast";
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      if (document.body.contains(notification)) {
        document.body.removeChild(notification);
      }
    }, 5000);
  }
}
